/**
 * The Workflow (agents) page's rows of the settings-search catalog, extracted
 * from `settingsSearch.ts` so that file stays within its size ratchet while
 * the page keeps growing rows. Same shape, same rules: the catalog stays the
 * single source of the rendered titles.
 *
 * @module
 */

export const WORKFLOW_SETTINGS_SEARCH_ROWS = [
  { id: "workflow-plan-approval", title: "Plan approval", to: "/settings/agents" },
  { id: "workflow-worker-spawn", title: "Worker spawn", to: "/settings/agents" },
  { id: "workflow-merge-strategy", title: "Merge strategy", to: "/settings/agents" },
  { id: "workflow-max-workers", title: "Max workers per master", to: "/settings/agents" },
  { id: "workflow-stuck-timeout", title: "Stuck timeout (minutes)", to: "/settings/agents" },
  {
    id: "workflow-notification-dedupe",
    title: "Notification dedupe window (seconds)",
    to: "/settings/agents",
  },
  { id: "workflow-worker-messaging", title: "Worker direct messaging", to: "/settings/agents" },
  { id: "workflow-brain-context", title: "Brain context", to: "/settings/agents" },
  { id: "workflow-web-search", title: "Web search", to: "/settings/agents" },
  { id: "workflow-brain-max-tokens", title: "Brain max tokens", to: "/settings/agents" },
  { id: "workflow-web-max-results", title: "Web max results", to: "/settings/agents" },
] as const;
